export const Tabs = ({ filters, activeFilter, onFilterChange }) => {
  return (
    <div style={styles.container}>
      {filters.map((filter, index) => (
        <button
          key={filter}
          onClick={() => onFilterChange(filter)}
          style={{
            ...styles.tab,
            ...(activeFilter === filter ? styles.tabActive : {}),
            ...(index === filters.length - 1 ? { borderRight: "none" } : {}),
          }}
        >
          {filter}
        </button>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    width: "fit-content",
    gap: "0",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    overflow: "visible",
  },
  tab: {
    padding: "8px 16px",
    border: "none",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    color: "#6B7280",
    borderRight: "1px solid #E5E7EB",
    transition: "all 150ms",
  },
  tabActive: {
    backgroundColor: "#F3F4F6",
    color: "#111827",
    fontWeight: "500",
  },
};
